import {ErrorBase} from "./ErrorBase";

export class Result<Type> {
    
    
    public errors: Array<ErrorBase>;

    public value?: Type;
    
    public hasErrors() {
        return this.errors.length > 0;
    }

    constructor(value: Type, errors: Array<ErrorBase>) {
        this.value = value;
        this.errors = errors;
    }

    static createSuccess<Type>(value: Type = undefined) {
        return new this(value, []);
    }

    public static createSuccessWithErrors<Type>(value: Type, errors: Array<ErrorBase>) {
        return new this(value, errors);
    }

    static createError<Type>(errors: Array<ErrorBase>) {
        return new this(<Type>null, errors);
    }
    
    
}